export const HOST = 'https://rent-lampa.fotolampa.com.ua';
// export const HOST = 'http://192.168.3.5:8089';
// export const HOST = 'http://192.168.3.7:8089';
// export const HOST = 'http://192.168.3.8:8089';
